import ActionMenu from './ActionMenu'

export default ActionMenu



// WEBPACK FOOTER //
// ./src/components/ActionMenu/index.js